<template>
  <div>
    <div
      v-if="isActive"
      class="click-area"
      @click="toggleDropdown"
    />
    <div class="category-filter">
      <span
        v-if="isActive"
        class="close"
        @click="toggleDropdown()"
      >X
      </span>

      <ul
        id="container"
        :class="{active: isActive}"
        class="dropdown"
      >
        <li
          @click="toggleDropdown()"
        >
          <template v-if="value != ''">
            <strong
              :key="1"
            >
              <span>
                {{ sortingTitle }}
              </span>
            </strong>
          </template>

          <template v-else>
            <div>
              <strong>Sort by <span>{{ selectedItem }}</span></strong>
            </div>
          </template>
        </li>
        <li
          v-for="(item, index) in items"
          :key="index"
          :class="{active: value.includes(item) }"
          @click="selectItem(item)"
        >
          <strong>{{ item.label }}</strong>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: 'select-dropdown-sort',
  props: {
    'items': {
      type: Array,
      required: true
    },
    'value': {
      type: String,
      required: true
    },
    'name': {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isActive: false,
      selectedItem: ''
    }
  },
  computed: {
    sortingTitle() {
      let title = this.items.filter(item => item.sortBy === this.value)
      return title[0].label
    }
  },
  methods: {
    selectItem: function(item) {
      this.selectedItem = item.sortBy
      this.isActive = false
      this.$emit('input', item.sortBy)
    },
    toggleDropdown() {
      this.isActive = !this.isActive
      if (!this.isActive) {
        this.$el.querySelector('#container').scrollTop = 0
      }
    }
  }
}
</script>

<style scoped lang="scss">
.click-area {
  opacity: 0;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 6;
}
    .category-filter {
        position: relative;

        .close {
            position: absolute;
            top: -1em;
            right: 0;
            color: var(--main-primary);
            font-size: 1.5em;
            font-weight: 200;
        }

        .clear {
            position: absolute;
            right: 0.25em;
            background: var(--main-secondary);
            color: var(--main-white);
            padding: 0 0.5em;
            display: block;
            height: 2em;
            line-height: 2em;
            top: 0.25em;
            z-index: 9;
            cursor: pointer;
            transition: var(--main-transition);

            &:hover {

                background: var(--main-secondary-dark);
            }

        }
        ul.dropdown {
            list-style: none;
            background: var(--main-white);
            height: 2.5em;
            line-height: 2;
            overflow: hidden;
            transition: ease-in-out all .2s;
            color: var(--main-text);
            position: absolute;
            width: 100%;
            z-index: 100;
            padding: 0;

            &.active {
                height: 15em;
                overflow-y: auto;
                width: 100%;
                box-shadow: var(--box-shadow-dropdown);
                z-index: 8;
                .clear {
                    display: none;
                }
            }

            li {

                z-index:1000;
                margin: 0;
                padding: 0.25em 1.5em;
                cursor: pointer;
                position: relative;

                .filter-tag {
                    border: 1px solid var(--main-border-color);
                    padding: .2em .5em;
                    border-radius: 1em;
                }

                &:hover {
                    color: var(--main-primary);
                    background: var(--main-light-grey);
                }
                &.active {
                    background: var(--main-light-grey);
                }
            }
        }
    }
</style>
